export const FETCH_CATEGORIES = 'categories/fetchAll';
